import AirPlay from '@mui/icons-material/Airplay';
import MeetingRoom from '@mui/icons-material/MeetingRoom';
import NoMeetingRoom from '@mui/icons-material/NoMeetingRoom';
import PlayIcon from '@mui/icons-material/PlayCircleOutline';
import SnoozeIcon from '@mui/icons-material/Snooze';
import StopIcon from '@mui/icons-material/Stop';
import { Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/botao.css';
import '../../css/cabecalho.css';
import Configuracao from '../../util/Configuracao';
import ReactComponent from '../ReactComponent';
import ModalConfirmacao from './ModalConfirmacao';

class ControleDeSessao extends ReactComponent {
    pendencias = undefined;
    abrirConfirmacaoFecharPauta = false;
    mensagemSucessoPauta;

    constructor(props) {
        super(props);

        makeObservable(this, {
            pendencias: observable,
            abrirConfirmacaoFecharPauta: observable,
            mensagemSucessoPauta: observable,
            statusDaSessao: computed,
            mudarStatus: action,
            fecharConfirmacaoFecharPauta: action
        });
    }

    get statusDaSessao() {
        return this.sessaoStore?.sessaoSelecionada?.situacao;
    }

    mudarStatus = (novoStatus) => {
        let statusAnterior = this.sessaoStore.sessaoSelecionada.situacao;
        let existeSessaoNoStatusAnterior = false;
        for (let sessaoSimples of this.sessaoStore.sessaoSelecionada.sessoes) {
            let statusAtualSessaoSimples = this.sessaoStore.sessaoSelecionada.situacoes[sessaoSimples.id];
            let quantidadeProcessosSessaoSimples = this.salaSessaoStore.getProcessosSessao(sessaoSimples.id).length;
            if (statusAtualSessaoSimples === statusAnterior && quantidadeProcessosSessaoSimples > 0) {
                existeSessaoNoStatusAnterior = true;
                break;
            }
        }
        if (!existeSessaoNoStatusAnterior) {
            this.sessaoStore.sessaoSelecionada.situacao = novoStatus;
            novoStatus === Configuracao.STATUS_INICIADA && this.observableProps.recarregarListaProcessos();
        }
    };

    validarFecharPauta(sessaoId) {
        const validacao = this.salaSessaoStore.validarFecharPauta(sessaoId);
        if (validacao.erro) {
            this.mensagemStore.abrirMensagemAlerta(validacao.mensagem);
            return false;
        } else {
            this.abrirConfirmacaoFecharPauta = true;
            this.mensagemSucessoPauta = validacao.mensagem;
            return true;
        }
    }

    confirmacaoDialog = () => {
        this.setStatus(Configuracao.STATUS_AGUARDANDO_SESSAO_JULGAMENTO);
    };

    // Altera os status de todas as sessoes simples que estejam no statusAtual da sessao composta.
    setStatus = async (novoStatus) => {
        let statusAtual = this.statusDaSessao;
        for (let sessaoSimples of this.sessaoStore.sessaoSelecionada.sessoes) {
            let statusAtualSessaoSimples = this.sessaoStore.sessaoSelecionada.situacoes[sessaoSimples.id];
            if (statusAtual === statusAtualSessaoSimples) {
                if (novoStatus === Configuracao.STATUS_AGUARDANDO_SESSAO_JULGAMENTO) {
                    await this.sessaoService.alterarSituacaoSessao(sessaoSimples.id, novoStatus);
                    runInAction(() => (this.sessaoStore.sessaoSelecionada.situacoes[sessaoSimples.id] = novoStatus));
                    this.mensagemStore.abrirMensagemSucesso('Pauta fechada');
                    this.abrirConfirmacaoFecharPauta = false;
                }
            }
        }
        this.mudarStatus(novoStatus);
    };

    handleClickMeetingRoom = () => {
        for (let sessaoSimples of this.sessaoStore.sessaoSelecionada.sessoes) {
            this.validarFecharPauta(sessaoSimples.id);
        }
    };

    tooltipAguardandoSessao = () => {
        return 'Aguardando sessão de julgamento.';
    };

    fecharConfirmacaoFecharPauta = () => {
        this.abrirConfirmacaoFecharPauta = false;
    };

    render() {
        if (!this.sessaoStore?.sessaoSelecionada || !this.sessaoStore?.existeSessaoPJe) {
            return null;
        }

        return (
            <div
                style={{ color: 'white' }}
                className="corBotaoAmarelo"
            >
                {this.renderSessaoAberta()}
                {this.renderAguardandoSessao()}
                {this.renderSessaoEmPlenarioVirtual()}
                {this.renderSessaoIniciada()}
                {this.renderSessaoFechada()}
                {this.renderConfirmacao()}
            </div>
        );
    }

    renderConfirmacao() {
        return (
            <ModalConfirmacao
                titulo={'Fechar Pauta'}
                open={this.abrirConfirmacaoFecharPauta}
                callbackCancelar={this.fecharConfirmacaoFecharPauta}
                callbackConfirmar={this.confirmacaoDialog}
            >
                <Typography display={'inline'}>{this.mensagemSucessoPauta}</Typography>
            </ModalConfirmacao>
        );
    }

    renderSessaoAberta() {
        return (
            (this.statusDaSessao === Configuracao.STATUS_ABERTA ||
                this.statusDaSessao === Configuracao.STATUS_NAO_GERENCIADA_ABERTA) && (
                <Tooltip
                    title={'Pauta ABERTA. Fechar a pauta?'}
                    placement="top-start"
                >
                    <MeetingRoom
                        style={{ verticalAlign: 'middle', margin: '8px', cursor: 'pointer' }}
                        onClick={this.handleClickMeetingRoom}
                    />
                </Tooltip>
            )
        );
    }

    renderAguardandoSessao() {
        return (
            this.statusDaSessao === Configuracao.STATUS_AGUARDANDO_SESSAO_JULGAMENTO && (
                <Tooltip
                    title={this.tooltipAguardandoSessao()}
                    placement="top-start"
                >
                    <SnoozeIcon style={{ verticalAlign: 'middle', margin: '8px' }} />
                </Tooltip>
            )
        );
    }

    renderSessaoEmPlenarioVirtual() {
        return (
            this.statusDaSessao === Configuracao.STATUS_PLENARIO_VIRTUAL && (
                <Tooltip
                    title={'Sessão em Plenário Virtual'}
                    placement="top-start"
                >
                    <AirPlay style={{ verticalAlign: 'middle', margin: '8px', cursor: 'pointer' }} />
                </Tooltip>
            )
        );
    }

    renderSessaoIniciada() {
        return (
            (this.statusDaSessao === Configuracao.STATUS_INICIADA ||
                this.statusDaSessao === Configuracao.STATUS_ENCERRADA) && (
                <Tooltip
                    title={'Sessão ' + this.statusDaSessao}
                    placement="top-start"
                >
                    {this.statusDaSessao === Configuracao.STATUS_ENCERRADA ? (
                        <StopIcon style={{ verticalAlign: 'middle', margin: '8px' }} />
                    ) : (
                        <PlayIcon style={{ verticalAlign: 'middle', margin: '8px' }} />
                    )}
                </Tooltip>
            )
        );
    }

    renderSessaoFechada() {
        return (
            (this.statusDaSessao === Configuracao.STATUS_FECHADA ||
                this.statusDaSessao === Configuracao.STATUS_NAO_GERENCIADA_FECHADA) && (
                <Tooltip
                    title={'Sessão FECHADA'}
                    placement="top-start"
                >
                    <NoMeetingRoom style={{ verticalAlign: 'middle', margin: '8px' }} />
                </Tooltip>
            )
        );
    }
}

export default inject('stores')(observer(ControleDeSessao));
